export default __webpack_public_path__ + "static/media/LOGO-RIT-PICTOGRAMME-BLANC.661beda4.png";